import React from 'react';
import Icon from '@mdi/react';
import { mdiEmailOutline, mdiAlert } from '@mdi/js';
import Lottie from 'lottie-react';
import SuccessLottie from './lottie-mail-alert.json';
import './notify.m.css';

const Notify = ({ mode, url, setter, title }) => {
  const clickOnCross = () => {
    setter(false);
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
    window.localStorage.removeItem('newsletter');
  };

  const clickOnAddEmail = () => {
    window.location = url;
  };

  return (
    <div styleName="notify-ctx">
      <div styleName={`notify-box ${mode === 'addNewsletter' ? 'more-height' : ''}`}>
        {mode === 'addEmail' && (
          <React.Fragment>
            <div styleName="logo-and-cross">
              <div styleName="notify-email-icon">
                <Icon path={mdiEmailOutline} size="35px" color="#8F9DA5" />
              </div>
              <div styleName="close-button" onClick={() => clickOnCross()}></div>
            </div>
            <div styleName="texts">
              <div styleName="notify-me">Update Email</div>
              <div styleName="message">to get newsletters straight to your inbox</div>
            </div>
            <div styleName="disclaimer">
              <Icon path={mdiAlert} size="13px" color="#CC9346" />
              <b>Add your Email ID </b>to receive Newsletters
            </div>
            <div styleName="update-email" onClick={() => clickOnAddEmail()}>Tap to Add Email</div>
            <div styleName="disclaimer-note">
              <em styleName="fw-500">Note :</em>&nbsp;<em>You will be signed up automatically after adding email</em>
            </div>
          </React.Fragment>
        )}
        {mode === 'addNewsletter' && (
          <div styleName="notify-success">
            <div styleName="close-button" onClick={() => clickOnCross()}></div>
            <Lottie
              animationData={SuccessLottie}
              loop={true}
              autoplay={true}
              styleName="notify-lottie"
            />
            <div styleName="title">You’re in the Mailing List</div>
            <div styleName="subtitle">You’ve successfully subscribed to <b>“{title}”</b> Newsletter</div>
            <div></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notify;
